var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2644 10.0293C18.2644 14.4473 10.2644 22.0293 10.2644 22.0293C10.2644 22.0293 2.2644 14.4473 2.2644 10.0293C2.2644 7.90757 3.10726 5.87273 4.60755 4.37244C6.10784 2.87215 8.14267 2.0293 10.2644 2.0293C12.3861 2.0293 14.421 2.87215 15.9213 4.37244C17.4215 5.87273 18.2644 7.90757 18.2644 10.0293V10.0293Z",
    stroke: "#063065",
    strokeWidth: 3.1544
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2644 11.0293C10.5296 11.0293 10.784 10.924 10.9715 10.7364C11.159 10.5489 11.2644 10.2945 11.2644 10.0293C11.2644 9.7641 11.159 9.50974 10.9715 9.32221C10.784 9.13467 10.5296 9.02931 10.2644 9.02931C9.99919 9.02931 9.74483 9.13467 9.5573 9.32221C9.36976 9.50974 9.2644 9.7641 9.2644 10.0293C9.2644 10.2945 9.36976 10.5489 9.5573 10.7364C9.74483 10.924 9.99919 11.0293 10.2644 11.0293Z",
    fill: "white",
    stroke: "#063065",
    strokeWidth: 3.1544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.c304f79dcacd314e73c5f664a2f0e67c.svg";
export { ForwardRef as ReactComponent };